import { render, staticRenderFns } from "./ChosenTags.vue?vue&type=template&id=e5904a3e"
import script from "./ChosenTags.vue?vue&type=script&lang=ts"
export * from "./ChosenTags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports